export type AuthMode = "demo" | "api";

export function getAuthMode(): AuthMode {
  return import.meta.env?.VITE_AUTH_MODE === "api" ? "api" : "demo";
}

export function getApiBaseUrl(): string {
  const raw = import.meta.env?.VITE_API_BASE_URL?.trim();
  return (raw && raw.length > 0 ? raw : "http://localhost:3000").replace(/\/$/, "");
}

export const AUTH_PUBLIC_PATHS = [
  "/login",
  "/mfa",
  "/mfa/setup",
  "/recuperar-senha",
  "/redefinir-senha",
] as const;
